/**
 * Auth V2 — API tenant prefix is URL slug only (no home-tenant remap).
 */
import { isPlatformChromeTenant } from '../../app/platformChromeTenant.js';
import { isReservedCustomerPathSegment } from '../../features/auth/customerAuthPaths.js';

export function hasCustomerApiTenant(urlTenantCode: string): boolean {
  const trimmed = urlTenantCode.trim();
  return (
    trimmed.length > 0 &&
    !isPlatformChromeTenant(trimmed) &&
    !isReservedCustomerPathSegment(trimmed)
  );
}

/** Real tenant slug for ApiClient prefix, or null on platform chrome / reserved paths. */
export function resolveCustomerApiTenantCode(urlTenantCode: string): string | null {
  return hasCustomerApiTenant(urlTenantCode) ? urlTenantCode.trim() : null;
}

/**
 * Org slug safe for account payment QR `?tenant=` — non-empty, not platform chrome,
 * not a reserved path segment. Callers omit `?tenant=` (or null qrHref) when null.
 */
export function usableAccountQrTenant(code: string): string | null {
  return resolveCustomerApiTenantCode(code);
}

/** Account nav tenant — URL tenant only (platform chrome stays `__platform__`). */
export function resolveAccountNavTenantCode(urlTenantCode: string): string {
  return urlTenantCode.trim();
}
